import { getBaseUrl } from './config'

function getCleanRedirectUrl(): string {
  try {
    if (!window.location?.href) return ''
    const currentUrl = new URL(window.location.href)
    return currentUrl.origin + currentUrl.pathname
  } catch {
    return ''
  }
}

export function sanitizeEmail(email: string): string {
  return email
    .toLowerCase()
    .trim()
    .replace(/[^\w@.+-]/g, '')
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export async function sendSignInLinkWithOTP(email: string): Promise<boolean> {
  try {
    const baseUrl = getBaseUrl()
    const redirectTo = getCleanRedirectUrl()

    const response = await fetch(`${baseUrl}/auth/email/send_link_with_otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, redirectTo }),
    })

    if (!response.ok) {
      throw new Error(
        `Failed to send sign-in link with otp: ${response.statusText}`,
      )
    }

    window.localStorage.setItem('emailForSignIn', email)
    return true
  } catch (error) {
    console.error('Error sending email link with otp:', error)
    return false
  }
}

export async function signInWithOTP(email: string, otp: string): Promise<void> {
  const baseUrl = getBaseUrl()
  const redirectTo = getCleanRedirectUrl()

  const response = await fetch(`${baseUrl}/auth/email/verify_otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, otp, redirectTo }),
  })

  if (response.ok) {
    const data = await response.json()
    if (data.success === true) {
      if (data.signin_url) {
        window.location.href = data.signin_url
        return
      } else {
        throw new Error('Internal error. Success but no signin_url provided.')
      }
    } else {
      throw new Error(data.error || 'Verification failed.')
    }
  }

  const errorData = await response.json().catch(() => ({}))
  throw new Error(errorData.message || 'Invalid OTP code. Please try again.')
}
